import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Currencies',
  basePath: '/currencies',
  columns: [
    { key: 'currency', label: 'Currency', sortable: true },
    { key: 'symbol', label: 'Symbol', sortable: true },
  ],
  fields: [
    { key: 'currency', label: 'Currency', type: 'text', required: true },
    { key: 'symbol', label: 'Symbol', type: 'text' },
  ],
  defaultSort: { field: 'currency', dir: 'asc' },
});
